import { version } from '../../../package.json'

export const clientVersion = version as string
